// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Typography from "@mui/material/Typography";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

type SecurityType = {
  title: string;
};

const Security = ({ title }: SecurityType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <OperatingManualContent title={title}>
      <Typography>
        {t(
          "We comply with all required laws, including data privacy and cybersecurity."
        )}
      </Typography>
    </OperatingManualContent>
  );
};

export default Security;
